import React from 'react'

import clsx from 'clsx'

import Grid from 'components/Grid'
import Rating from 'components/Rating'
import Typography from 'components/Typography'
import { useAppContext } from 'context/AppContext'
import { useListingDetailContext } from 'context/ListingDetailContext'
import useViewport from 'hooks/useViewport'
import PPLBanner from 'screens/listingDetail/components/TableOfContent/components/PPLBanner'

import TextBase from '../TextBase'

import classes from './KeyFeatures.module.scss'

/** @type {import("./types").default} */
const KeyFeatures = ({ text, features, bxListing, className }) => {
  const { head } = useAppContext()
  const hasPPLDemoForm = head?.hasPplDemoFormEnabled
  const { up } = useViewport()
  const isDesktop = up('md')

  const { listing } = useListingDetailContext()
  const featuresRatings = bxListing?.features?.nodes.reduce((acc, feature) => {
    acc[feature.id] = feature.ratingSummary
    return acc
  }, {})

  return (
    <section className={clsx('PopularComparisons', classes.root, className)}>
      <TextBase title={`${listing.name}’s key features rated by users`} className={classes.title} />
      <TextBase text={text} />
      <Grid spacing={2} container>
        {features.map((feature, index) => (
          <React.Fragment key={feature.id}>
            <Grid item xs={12} className={classes.nameContainer}>
              <Typography variant="body-sm" className={classes.featureName}>
                {feature.name}
              </Typography>
              <Rating.Link
                average={featuresRatings[feature.id]?.qualityRating || 0}
                totals={featuresRatings[feature.id]?.qualityRatingCount || 0}
                isCompact
              />
            </Grid>
            <Grid item xs={12}>
              <TextBase text={feature.text} className={index === features.length - 1 ? classes.noBottomPadding : ''} />
            </Grid>
          </React.Fragment>
        ))}
      </Grid>
      {hasPPLDemoForm && !isDesktop && <PPLBanner />}
    </section>
  )
}
export default KeyFeatures
